export const SOCKET_ADMINS = {
    ADMIN_PASSWORD_CREATED: 'admin_create_password',
    ADMIN_CHANGE_EMAIL: 'admin_change_email'
}